"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonApps = _interopRequireDefault(require("./ButtonApps"));

var _AppsDropdown = _interopRequireDefault(require("./AppsDropdown"));

var _AppsByUser = _interopRequireDefault(require("./AppsByUser"));

var _AppsByOwner = _interopRequireDefault(require("./AppsByOwner"));

var _AppsOwnersList = _interopRequireDefault(require("./AppsOwnersList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AppsButtonRef = _react.default.forwardRef((props, ref) => {
  return _react.default.createElement(_ButtonApps.default, _extends({}, props, {
    forwardedRef: ref
  }));
});

const NavApps = (_ref) => {
  let className = _ref.className,
      uniqueId = _ref.uniqueId,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      owner = _ref.owner,
      apps = _ref.apps,
      owners = _ref.owners,
      onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "uniqueId", "user", "owner", "apps", "owners", "onSelect"]);

  const _useState = (0, _react.useState)(props.expanded),
        expanded = _useState[0],
        setExpanded = _useState[1];

  const _useState2 = (0, _react.useState)(owner && owner.uniqueId),
        currentOwnerId = _useState2[0],
        setCurrentOwnerId = _useState2[1];

  const anchorRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (owner && owner.uniqueId) {
      setCurrentOwnerId(owner.uniqueId);
    }
  }, [owner]);

  if (!apps && user && user.apps) {
    apps = user.apps;
  }

  if (!owners && user && user.owners) {
    owners = user.owners;
  }

  if (!apps) {
    return null;
  }

  const handleToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const selectOwner = owner => {
    setCurrentOwnerId(owner && owner.uniqueId);
    onSelect && onSelect(owner);
  };

  const unselectOwner = () => {
    setCurrentOwnerId(null);
  };

  const selectApp = item => {
    setExpanded(false);
    onSelect && onSelect(item);
  };

  const handleCollapse = () => {
    setExpanded(false);
  };

  let currentOwner;

  if (owners && currentOwnerId) {
    currentOwner = owners.filter(owner => owner.uniqueId === currentOwnerId)[0];
  }

  if (!user.uniqueId) {
    return false;
  }

  return _react.default.createElement("nav", {
    className: className
  }, _react.default.createElement(AppsButtonRef, {
    onClick: handleToggle,
    expanded: expanded,
    ref: anchorRef
  }), _react.default.createElement(_AppsDropdown.default, {
    expanded: expanded,
    anchorEl: anchorRef.current,
    arrowRef: anchorRef,
    onCollapse: handleCollapse
  }, apps && _react.default.createElement(_AppsByUser.default, {
    apps: apps,
    onSelect: selectApp
  }), currentOwner && _react.default.createElement(_AppsByOwner.default, _extends({}, currentOwner, {
    onCollapse: unselectOwner,
    onSelect: selectApp
  })), !currentOwner && owners && _react.default.createElement(_AppsOwnersList.default, {
    owners: owners,
    onSelect: selectOwner
  })));
};

NavApps.propTypes = process.env.NODE_ENV !== "production" ? {
  apps: _propTypes.default.array,
  owners: _propTypes.default.array,
  ownerId: _propTypes.default.string,
  onSelect: _propTypes.default.func
} : {};
var _default = NavApps;
exports.default = _default;
module.exports = exports.default;